import React, { FC, memo, useMemo, useRef, useState } from 'react';
import { useRequest } from 'ahooks';
import { useSearchParams } from './hooks';
import { Spin } from 'udesk-ui';
import { Wrapper, Content, Footer } from './components';
import OverviewPad from './components/OverviewPad';
import DetailPad from './components/DetailPad';
import Audio from './components/Audio';
import { getFindLatestData, getInspectionData } from './api';
import { BaseResponseInspectionDataWrapper, InspectionDataWrapper } from '../../../api/types';

interface TemplateProps {}

const Template: FC<TemplateProps> = memo(() => {
    const { callId, domain, email, timestamp, sign } = useSearchParams();

    const [latestData, setLatestData] = useState<any>();

    const { loading: getFindLatestDataLoading } = useRequest(
        () =>
            getFindLatestData({
                callId,
                domain,
                email,
                timestamp,
                sign,
            }),
        {
            ready: !!callId,
            onSuccess: (res: any) => {
                setLatestData(res.data);
            },
        }
    );

    const [inspectDetail, setInspectDetail] = useState<InspectionDataWrapper>();

    const { loading: getInspectionDataLoading } = useRequest(
        () =>
            getInspectionData({
                taskId: latestData?.taskId,
                inspectId: latestData?.id,
                domain,
                email,
                timestamp,
                sign,
            }),
        {
            ready: !!latestData?.taskId && !!latestData?.id,
            onSuccess: (res: BaseResponseInspectionDataWrapper) => {
                setInspectDetail(res.data);
            },
        }
    );

    const hasAudio = useMemo(() => inspectDetail?.voiceUrl, [inspectDetail]);

    const AudioRef = useRef<any>(null);

    return (
        <Wrapper>
            <Spin spinning={getFindLatestDataLoading || getInspectionDataLoading}>
                <Content hasAudio={hasAudio}>
                    <OverviewPad latestData={latestData} />

                    <DetailPad
                        inspectDetail={inspectDetail}
                        playSpecificTimePeriod={(start, end) =>
                            AudioRef.current?.playSpecificTimePeriod(
                                start,
                                end,
                                AudioRef.current?.duration
                            )
                        }
                    />
                </Content>

                <Footer hasAudio={hasAudio}>
                    <Audio src={inspectDetail?.voiceUrl} AudioRef={AudioRef} />
                </Footer>
            </Spin>
        </Wrapper>
    );
});

export default Template;
